import { render, staticRenderFns } from "./SizeFilters.vue?vue&type=template&id=55287042&"
import script from "./SizeFilters.vue?vue&type=script&lang=js&"
export * from "./SizeFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports